module.exports = __webpack_public_path__ + "static/media/spinner.be00fc4a.svg";